{
  "title": "Launchpad by Salt",
  "subtitle": "Your church's sermons, worship songs, and events. Open the link your church shared, or get the Salt app to keep up with them."
}
